(() => {
  window.swinger.eventHub.register('click', '.swinger-button-scheme-switch', (e) => {
    const elem = window.swinger.eventHub.getTarget(e).closest('.swinger-button-scheme-switch');
    const pressedState = elem.getAttribute('aria-pressed');
    let newPressedState;
    switch (pressedState) {
      default:
        newPressedState = 'false';
        break;
      case 'true':
        newPressedState = 'mixed';
        break;
      case 'false':
        newPressedState = 'true';
        break;
    }
    elem.setAttribute('aria-pressed', newPressedState);

    const mode = {
      false: 'light',
      true: 'dark',
      mixed: 'auto',
    }[newPressedState];
    window.swinger.user.setDisplayMode(mode);

    window.swinger.audioHapticFeedback.trigger('press');

    window.swinger.i18n()
      .then((i18n) => {
        window.swinger.snackbar.create({
          isSelfclosing: true,
          children: [
            {
              component: 'notification',
              data: {
                type: 'info',
                text: `${i18n(`ui.button-scheme-switch.${mode}.label`)}. ${i18n(`ui.button-scheme-switch.${mode}.usage-info`)}`,
              },
            },
          ],
        });
      })
      .catch(console.info);
  });
})();
